// Reach and Range share the same scale: 1 = touching base edges, then each
// additional step adds 1.5 meters of gap. Targeting applies geometry epsilon.
export function reachRangeToMeters(steps: number): number {
  if (!Number.isFinite(steps) || steps < 1) throw new RangeError('Reach/Range must be at least 1.');
  return (steps - 1) * 1.5;
}

export const STANDARD_MELEE_REACH = reachRangeToMeters(1);
/** A Reach 1 action (a swing, a touch power, a potion handed over) starts in base contact, and still lands if the target has drifted up to this gap away (meters). */
export const TOUCH_REACH = .75;
/** The gap at which an action begun within `meters` still lands: `TOUCH_REACH` for Reach 1, the distance itself beyond. */
export const holdReach = (meters: number) => meters <= STANDARD_MELEE_REACH ? TOUCH_REACH : meters;
/** Two foes are adjacent for a split spell (Razor Wind) when at most one space (1.5 m) separates their bases: a video-game reading of "adjacent". */
export const ADJACENT_FOES = reachRangeToMeters(2);
/** A Prone creature spends 3 spaces of Speed to stand (Core p. 11). */
export const STAND_UP_METERS = 3 * 1.5;
/** A Speed of 6 spaces (9 m). */
export const DEFAULT_MOVEMENT_METERS = 9;
/** Heroes closer than this (base edge to base edge, in meters) wake a monster group and start the fight. */
export const ENGAGEMENT_DISTANCE = 10;
/** Baseline pace for Speed 6; a unit's movement distance scales its actual ground speed. */
export const WALK_SPEED = 3.2;
export function speedForMovementDistance(baseSpeed: number, movementDistance: number): number {
  return baseSpeed * movementDistance / DEFAULT_MOVEMENT_METERS;
}
